import type { AppContext } from 'types/common'
import OAuthCallback from './OAuthCallback.svelte'

export default function ({ stateRouter }: AppContext) {
	stateRouter.addState({
		name: 'oauth-callback',
		route: 'oauth-callback',
		querystringParameters: ['error'],
		template: {
			svelte: true,
			component: OAuthCallback,
		},
		resolve(_data, parameters) {
			return Promise.resolve({
				error: parameters.error as string | undefined,
			})
		},
	})
}
